import {initWebComponent} from "@/helpers/web-component-helper";
import {activateUserSessionByID, disableUserSessionByID, getUserSessionByID} from "@/helpers/user-session-helper";
import {
    addClassBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {initPopper} from "@/modules/popper.js";

export class BookmarkUserSessionStartButtonComponent extends HTMLElement {
    constructor(){
        super();

        let active = Boolean(this.getAttribute('data-active'))
        const id = this.getAttribute('data-id')

        const template = document.createElement('template');

        template.innerHTML = `<button class="btn btn-sm btn-outline-secondary btn-sm text-transform-none">
           <span class="spn-user-session-start"><i class="fa fa-play"></i> Start</span>
        </button>`
        initWebComponent(this, template)

        this.addEventListener('click', () => {

            active = true
            if(this.querySelector('.spn-user-session-start').classList.contains('d-none')) {
                active = false
            }

            removeClassBySelector('.card-user-session', 'bg-light')
            // hideElementsBySelector('.buttons-user-session')
            showElementsBySelector('.spn-user-session-start')
            hideElementsBySelector('.spn-user-session-stop')

            if(active) {
                activateUserSessionByID(id)
                this.closest('.card').classList.add('bg-light')
            } else {
                disableUserSessionByID(id)
            }

            initPopper()

        })
    }
}
